export function isBlacklistedFilter(filter: string): boolean{
    return (
        filter === 'family' ||
        filter === 'foundry' ||
        filter === 'layout' ||
        filter === 'name' ||
        filter === 'page' ||
        filter === 'parametric_width' ||
        filter === 'parametric_weight'
    );
}